"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.NonAcceptedChildError = exports.WrongAttributeTypeError = exports.UnknownAttributeError = exports.UnknownNodeError = exports.isKindType = exports.isNoteType = exports.isBooleanString = exports.isDisplayExpanse = exports.isDisplayFrame = exports.isDisplayScale = exports.isDITAARCH = exports.isINCLUDED_DOMAINS = exports.isNMTOKENS = exports.isNMTOKEN = exports.isPCDATA = exports.isCDATA = exports.isID = exports.isXmlSpace = exports.isTableScope = exports.isProcessingRole = exports.isReferenceContentScope = void 0;
/**
 * isReferenceContentScope - Checks if a value is a ReferenceContentScope
 *
 * @param value - String
 * @returns - If the value is a ReferenceContentScope
 */
const isReferenceContentScope = (value) => ['local', 'peer', 'external'].includes(value);
exports.isReferenceContentScope = isReferenceContentScope;
/**
 * ProcessingRole validation function
 *
 * @param value - String
 * @returns - If the value is a ProcessingRole
 */
const isProcessingRole = (value) => ['normal', 'resource-only'].includes(value);
exports.isProcessingRole = isProcessingRole;
/**
 * isScope validation function
 *
 * @param value - String
 * @returns - If the value is a TableScope
 */
const isTableScope = (value) => ['row', 'col', 'rowgroup', 'colgroup'].includes(value);
exports.isTableScope = isTableScope;
/**
 * XmlSpace validation function
 *
 * @param value - String
 * @returns - If the value is a xmlSpace type
 */
const isXmlSpace = (value) => ['preserve'].includes(value);
exports.isXmlSpace = isXmlSpace;
/**
 * Id validation function
 */
const isID = (value) => typeof value === 'string';
exports.isID = isID;
/**
 * CDATA validation function
 */
const isCDATA = (value) => typeof value === 'string';
exports.isCDATA = isCDATA;
/**
 * PCData validation function
 */
const isPCDATA = (value) => typeof value === 'string';
exports.isPCDATA = isPCDATA;
/**
 * NMTOKEN validation function
 */
const isNMTOKEN = (value) => typeof value === 'string';
exports.isNMTOKEN = isNMTOKEN;
/**
 * NMTOKENS validation function
 */
const isNMTOKENS = (value) => typeof value === 'string';
exports.isNMTOKENS = isNMTOKENS;
/**
 * INCLUDED_DOMAINS validation function
 */
const isINCLUDED_DOMAINS = (value) => typeof value === 'string';
exports.isINCLUDED_DOMAINS = isINCLUDED_DOMAINS;
/**
 * INCLUDED_DOMAINS validation function
 */
const isDITAARCH = (value) => typeof value === 'string';
exports.isDITAARCH = isDITAARCH;
/**
 * DisplayScale validation function
 */
const isDisplayScale = (value) => [50, 60, 70, 80, 90, 100, 110, 120, 140, 160, 180, 200].indexOf(value) > -1;
exports.isDisplayScale = isDisplayScale;
/**
 * DisplayAlign validation function
 */
const isDisplayFrame = (value) => ['all', 'bottom', 'none', 'sides', 'top', 'topbot'].indexOf(value) > -1;
exports.isDisplayFrame = isDisplayFrame;
/**
 * DisplayAlign validation function
 */
const isDisplayExpanse = (value) => ['column', 'page', 'spread', 'textline'].indexOf(value) > -1;
exports.isDisplayExpanse = isDisplayExpanse;
/**
 * BooleanString validation function
 */
const isBooleanString = (value) => ['true', 'false'].indexOf(value) > -1;
exports.isBooleanString = isBooleanString;
/**
 * NoteType validation function
 */
const isNoteType = (value) => ['caution', 'warning', 'danger', 'trouble', 'notice', 'note'].indexOf(value) > -1;
exports.isNoteType = isNoteType;
/**
 * KindType validation function
 */
const isKindType = (value) => ['subtitles', 'captions', 'descriptions', 'chapters', 'metadata'].indexOf(value) > -1;
exports.isKindType = isKindType;
/**
 * Typedef for UnknownNodeError
 */
class UnknownNodeError extends Error {
    constructor() {
        super(...arguments);
        this.name = 'unknown-node';
    }
}
exports.UnknownNodeError = UnknownNodeError;
/**
 * Typedef for UnknownAttributeError
 */
class UnknownAttributeError extends Error {
    constructor() {
        super(...arguments);
        this.name = 'unknown-attribute';
    }
}
exports.UnknownAttributeError = UnknownAttributeError;
/**
 * Typedef for UnknownChildError
 */
class WrongAttributeTypeError extends Error {
    constructor() {
        super(...arguments);
        this.name = 'wrong-attribute-type';
    }
}
exports.WrongAttributeTypeError = WrongAttributeTypeError;
/**
 * Typedef for UnknownChildError
 */
class NonAcceptedChildError extends Error {
    constructor() {
        super(...arguments);
        this.name = 'non-accepted-child';
    }
}
exports.NonAcceptedChildError = NonAcceptedChildError;
//# sourceMappingURL=ast-classes.js.map